import { z } from "zod";

export const UserRoleSchema = z.enum(["financial_operator", "admin", "collection_operator"]);
export type UserRole = z.infer<typeof UserRoleSchema>;

export const LoginRequestSchema = z.object({
  email: z.string().email(),
  password: z.string().min(1),
});
export type LoginRequest = z.infer<typeof LoginRequestSchema>;

export const LoginResponseSchema = z.object({
  access_token: z.string(),
  expires_in: z.number(),
  user: z.object({
    id: z.string().uuid(),
    email: z.string().email(),
    name: z.string(),
    role: UserRoleSchema,
  }),
});
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

export const AuthUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  role: UserRoleSchema,
});
export type AuthUser = z.infer<typeof AuthUserSchema>;

export const JwtPayloadSchema = z.object({
  sub: z.string().uuid(),
  jti: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: UserRoleSchema,
  iat: z.number(),
  exp: z.number(),
});
export type JwtPayload = z.infer<typeof JwtPayloadSchema>;

export const CreateUserRequestSchema = z.object({
  name: z.string().min(2),
  email: z.string().email(),
  password: z.string().min(8),
  role: UserRoleSchema.default("financial_operator"),
});
export type CreateUserRequest = z.infer<typeof CreateUserRequestSchema>;

export const UserListItemSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  role: UserRoleSchema,
  is_active: z.boolean(),
  created_at: z.string(),
});
export type UserListItem = z.infer<typeof UserListItemSchema>;
